import { render, staticRenderFns } from "./UProCouponDialog.vue?vue&type=template&id=ff544776&"
import script from "./UProCouponDialog.vue?vue&type=script&lang=ts&"
export * from "./UProCouponDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports